import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import { ScreenReadersPageTitle } from '@futrli/ui-components';

import { EditableText } from '../editable-text/editable-text';
import { useReportBuilderContext } from '../../report-builder.context';

import styles from './report-title.scss';

const UPDATE_NAME_DELAY_TIME = 3000;

interface Props {
  disableEdit?: boolean;
}
export const ReportTitle = ({ disableEdit }: Props) => {
  const {
    reportTitle,
    updateReportTitle,
    pageSetup: { orientation },
    getPageWidth,
    isViewPage,
    setIsAutoSaving,
    setIsEditingTitle
  } = useReportBuilderContext();
  const [reportName, setReportName] = useState(reportTitle);
  const updateReportTitleTimer = useRef<number | null>(null);
  const isReadOnly = disableEdit || isViewPage;

  useEffect(() => {
    if (updateReportTitleTimer.current) {
      clearTimeout(updateReportTitleTimer.current);
    }
    setIsAutoSaving(reportName !== reportTitle && !!reportName.length);
    updateReportTitleTimer.current = (setTimeout(() => {
      if (reportName !== reportTitle && reportName.length) {
        updateReportTitle(reportName);
      }
    }, UPDATE_NAME_DELAY_TIME) as unknown) as number;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportName]);

  useEffect(() => {
    setReportName(reportTitle);
  }, [reportTitle]);

  return (
    <>
      <ScreenReadersPageTitle>{reportName}</ScreenReadersPageTitle>
      <h2 className={clsx(styles.reportTitle)} style={{ width: orientation === 'dashboard' ? 'auto' : getPageWidth() }}>
        {isReadOnly ? (
          reportName
        ) : (
          <EditableText
            text={reportName}
            onTextChange={setReportName}
            initialText={reportTitle}
            setIsEditing={setIsEditingTitle}
          />
        )}
      </h2>
    </>
  );
};
